import React from "react";

export function Technology({
	exportOptionsAvailable = true,
}: {
	exportOptionsAvailable?: boolean;
}) {
	return (
		<section className="section--technology">
			<div className="container">
				<p className="section-title with-square with-square--small">
					State-of-the-art technology
				</p>
				<ul className="features-list">
					<li>
						<img
							src="/static/img/icons/icon-airline-news.svg"
							alt=""
						/>
						<p className="title">
							Mobile and multi-device-friendly interface for
							convenient access anywhere
						</p>
					</li>
					<li>
						<img
							src="/static/img/icons/icon-airline-data.svg"
							alt=""
						/>
						<p className="title">
							Advanced search capabilities with numerous filters
						</p>
					</li>
					<li>
						<img src="/static/img/icons/icon-contacts.svg" alt="" />
						<p className="title">
							Google-style search field for faster website
							navigation
						</p>
					</li>
					{exportOptionsAvailable && (
						<li>
							<img
								src="/static/img/icons/icon-schedules.svg"
								alt=""
							/>
							<p className="title">
								Export options* for data in various formats
							</p>
							<p className="description">
								*at an additional cost
							</p>
						</li>
					)}
				</ul>
			</div>
		</section>
	);
}
